import ProductDetailsForm from './ProductDetailsForm'

export default ProductDetailsForm
